import Currency from "@tadashi/currency";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('input[type="text"].money').forEach((input) => {
    new Currency(input, {
      init: true,
      maskOpts: {
        locales: "pt-BR",
        options: {
          style: "currency",
          currency: "BRL",
          signDisplay: "never",
        },
      },
    });
  });
});
